<script setup>
import { ref, computed, watch } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import { useFirmwaresStore } from '@/stores/firmwares'
import { useCarsStore } from '@/stores/cars'
import { useCarsGroupsStore } from '@/stores/cars-groups'
import Modal from '@/components/UTAModal.vue'
import UTAListSelector from '@/components/UTAListSelector.vue'

async function getList(outerParams) {

    let params = {
        'c.limit': 12
    }

    if(inputSearch.value.length > 2)
        params['c.q'] = inputSearch.value

    if(searchMode.value) 
        params['c.filterQ'] = searchMode.value

    if(outerParams) 
        params = { ...params, ...outerParams }

    firmwaresStore.readFirmwares(params)

    return firmwares
}

function addItem(item) {
    selectedItems.value.push(item)
}

function deleteItem(item) {
    selectedItems.value = selectedItems.value.filter(selectedItem => selectedItem.uuid !== item.uuid)
}

function changePage(cursor, dir) {

    const params = {

        'c.limit': 12, 
        'c.direction': dir, 
        'c.cursor': cursor
    }

    firmwaresStore.readFirmwares(params).then(firmwares => {

        if(firmwares.value.array) {

            dir == 'after' ? 
                pageNumber.value++ : 
                pageNumber.value--
        }
    })
}

function addFile(event) {

    if(event.target?.files) {
        delete formInvalids.value.UTAFirmwaresUploadFile
        UTAFirmwaresUploadFile.value = event.target.files[0]
    } else {
        UTAFirmwaresUploadFile.value = null
    }
}

function submitFirmwaresForm() {

    formErrors.value = []
    formInvalids.value = {}

    let form = new FormData()

    if(UTAFirmwaresUploadMethod.value) {
        let methodKey = ''
        if(UTAFirmwaresUploadMethod.value == "cars") {
            methodKey = 'uuid_car_array'
        } else if(UTAFirmwaresUploadMethod.value == "groups") {
            methodKey = 'uuid_cgroup_array'
        }
        if(selectedItems.value.length !== 0) {
            selectedItems.value.map(item => form.append(methodKey, item.uuid))
        } else {
            if(UTAFirmwaresUploadMethod.value !== 'all') {

                formErrors.value.push(getTranslate.value['FIRMWARES_CREATE_SELECT_ELEMENTS'])
                formInvalids.value.UTAFirmwaresSelectElements = true
            }
        }
    } else {
        formErrors.value.push('UTAFirmwaresUploadMethod')
        formInvalids.value.UTAFirmwaresUploadMethod = true
    }

    if(UTAFirmwaresUploadDevice.value) {
        form.append('device', UTAFirmwaresUploadDevice.value)
    } else {
        formErrors.value.push('UTAFirmwaresUploadDevice')
        formInvalids.value.UTAFirmwaresUploadDevice = true
    }

    if(UTAFirmwaresUploadFile.value) {
        form.append('upFile', UTAFirmwaresUploadFile.value)
    } else {
        formErrors.value.push('UTAFirmwaresUploadFile')
        formInvalids.value.UTAFirmwaresUploadFile = true
    }

    if(UTAFirmwaresUploadModule.value) {
        form.append('module_type', UTAFirmwaresUploadModule.value)
    } else {
        formErrors.value.push('UTAFirmwaresUploadModule')
        formInvalids.value.UTAFirmwaresUploadModule = true
    }

    if(UTAFirmwaresUploadVersion.value) {
        form.append('software_version', UTAFirmwaresUploadVersion.value)
    } else {
        formErrors.value.push('UTAFirmwaresUploadVersion')
        formInvalids.value.UTAFirmwaresUploadVersion = true
    }

    if(formErrors.value.length == 0) {
        firmwaresStore.createFirmwares(form)
    }
}

const translaterStore           = useTranslaterStore()
const firmwaresStore            = useFirmwaresStore()
const carsStore                 = useCarsStore()
const carsGroupsStore           = useCarsGroupsStore()

const getTranslate              = computed(() => translaterStore.getTranslate)
const firmwares                 = computed(() => firmwaresStore.firmwares)
const firmwaresProcess          = computed(() => firmwaresStore.firmwaresProcess)
const firmwaresDeleteProcess    = computed(() => firmwaresStore.firmwaresDeleteProcess)
const firmwaresMsg              = computed(() => firmwaresStore.firmwaresMsg)
const firmwaresCreateMsg        = computed(() => firmwaresStore.firmwaresCreateMsg)
const firmwareDeleteMsg         = computed(() => firmwaresStore.firmwareDeleteMsg)

const sourceList = computed(() => {

    if(UTAFirmwaresUploadMethod.value == 'cars') return carsStore.readCars
    if(UTAFirmwaresUploadMethod.value == 'groups') return carsGroupsStore.readCarsGroups
    return false
})

const sourceListNames = computed(() => {

    if(UTAFirmwaresUploadMethod.value == 'cars') return ['data.imei', 'data.vin']
    if(UTAFirmwaresUploadMethod.value == 'groups') return ['name', 'description']
    return []
})

const sourceListLabels = computed(() => {

    if(UTAFirmwaresUploadMethod.value == 'cars') return ['CARS_VIN', 'CARS_IMEI']
    if(UTAFirmwaresUploadMethod.value == 'groups') return ['CARS_GROUPS_NAME', 'CARS_GROUPS_DESCR']
    return []
})

const inputSearch               = ref('')
const pageNumber                = ref(1)
const searchMode                = ref(null)
const searchModeText            = ref('FIRMWARES_SEARCH_MODE_ALL')
const formInvalids              = ref({})
const formErrors                = ref([])
const selectedItems             = ref([])
const showFirmwaresSelector     = ref(false)
const showFirmwareDelete        = ref(false)
const deleteFirmwareName        = ref(null)

const UTAFirmwaresUploadMethod  = ref('')
const UTAFirmwaresUploadDevice  = ref('')
const UTAFirmwaresUploadFile    = ref(null)
const UTAFirmwaresUploadModule  = ref('')
const UTAFirmwaresUploadVersion = ref('')

getList()

watch(inputSearch, () => {

    pageNumber.value = 1
    getList()
})

watch(UTAFirmwaresUploadMethod, () => {

    selectedItems.value = []
})

watch(firmwaresCreateMsg, msg => {

    if(msg.success) {

        getList()
    }
})

watch(firmwareDeleteMsg, msg => {

    if(msg.success) {

        getList()
        showFirmwareDelete.value = false
    }
})

</script>

<template>
    <div class="my-4 uta-firmwares">
        <div class="container-fluid">
            <header class="uta-header" role="heading" aria-level="1">
                <h1 class="uta-header__title">{{ getTranslate.FIRMWARES_TITLE }}</h1>
                <div class="spinner-border uta-header__spinner" role="status" v-if="firmwaresProcess">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </header>
            <form class="uta-firmwares__form" @submit.prevent="submitFirmwaresForm()">
                <div class="row">
                    <div class="col-12 col-md-4 my-2">
                        <label for="UTAFirmwaresUploadMethod">{{ getTranslate.FIRMWARES_FORM_METHOD }}:</label>
                        <select 
                            id="UTAFirmwaresUploadMethod" 
                            v-model="UTAFirmwaresUploadMethod"
                            class="uta-input uta-input--sm uta-input--block"
                            :class="{ 'uta-input--invalid' : formInvalids.UTAFirmwaresUploadMethod }"
                            @change="delete formInvalids.UTAFirmwaresUploadMethod"
                        >
                            <option value="" selected>...</option>
                            <option value="cars">{{ getTranslate.FIRMWARES_FORM_METHOD_CARS }}</option>
                            <option value="groups">{{ getTranslate.FIRMWARES_FORM_METHOD_GROUPS }}</option>
                            <option value="all">{{ getTranslate.FIRMWARES_FORM_METHOD_ALL }}</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-4 my-2">
                        <label for="UTAFirmwaresUploadDevice">{{ getTranslate.FIRMWARES_FORM_DEVICE }}:</label>
                        <select 
                            id="UTAFirmwaresUploadDevice" 
                            v-model="UTAFirmwaresUploadDevice" 
                            class="uta-input uta-input--sm uta-input--block"
                            :class="{ 'uta-input--invalid': formInvalids.UTAFirmwaresUploadDevice }"
                            @change="delete formInvalids.UTAFirmwaresUploadDevice"
                        >
                            <option value="">...</option>
                            <option value="SDM_V1_2">{{ getTranslate.FIRMWARES_FORM_DEVICE_12 }}</option>
                            <option value="SDM_V3_0" disabled>{{ getTranslate.FIRMWARES_FORM_DEVICE_30 }}</option>
                            <option value="NAMI_INTELCOM_V2_1_7">{{ getTranslate.FIRMWARES_FORM_DEVICE_IC_217 }}</option>
                            <option value="NAMI_INTELCOM_V2_1_7_1_3">{{ getTranslate.FIRMWARES_FORM_DEVICE_IC_21713 }}</option>
                            <option value="NAMI_INTELCOM_V2_1_7_1_4">{{ getTranslate.FIRMWARES_FORM_DEVICE_IC_21714 }}</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-4 my-2">
                        <label for="UTAFirmwaresUploadFile">{{ getTranslate.FIRMWARES_FORM_FILE }}:</label>
                        <input 
                            id="UTAFirmwaresUploadFile" 
                            name="upFile" 
                            @change="addFile" 
                            type="file" 
                            class="uta-input uta-input--sm uta-input--block"
                            :class="{ 'uta-input--invalid': formInvalids.UTAFirmwaresUploadFile }"
                        >
                    </div>
                    <div class="col-12 col-md-4 my-2">
                        <label for="UTAFirmwaresUploadModule">{{ getTranslate.FIRMWARES_FORM_MODULE }}:</label>
                        <input 
                            id="UTAFirmwaresUploadModule" 
                            name="module_type"
                            v-model="UTAFirmwaresUploadModule" 
                            type="text" 
                            class="uta-input uta-input--sm uta-input--block"
                            :class="{ 'uta-input--invalid': formInvalids.UTAFirmwaresUploadModule }"
                            @change="delete formInvalids.UTAFirmwaresUploadModule"
                        >
                    </div>
                    <div class="col-12 col-md-4 my-2">
                        <label for="UTAFirmwaresUploadVersion">{{ getTranslate.FIRMWARES_FORM_VERSION }}:</label>
                        <input 
                            id="UTAFirmwaresUploadVersion" 
                            name="software_version"
                            v-model="UTAFirmwaresUploadVersion" 
                            type="text" 
                            class="uta-input uta-input--sm uta-input--block"
                            :class="{ 'uta-input--invalid': formInvalids.UTAFirmwaresUploadVersion }"
                            @change="delete formInvalids.UTAFirmwaresUploadVersion"
                        >
                    </div>
                    <div class="col-12 col-md-4 my-2 d-flex align-items-end">
                        <button 
                            type="submit" 
                            class="uta-btn uta-btn--main uta-btn--block uta-btn--sm"
                        >
                            {{ getTranslate.BTN_UPLOAD }}
                        </button>
                    </div>
                </div>
                <div 
                    class="uta-firmwares__destination" 
                    v-if="
                        UTAFirmwaresUploadMethod == 'cars' || 
                        UTAFirmwaresUploadMethod == 'groups'
                    "
                >
                    <template v-if="selectedItems.length">
                        <div class="uta-firmwares__destination-list">
                            <template v-if="UTAFirmwaresUploadMethod == 'cars'">
                                <div 
                                    class="uta-firmwares__destination-list-item"
                                    v-for="selectedItem in selectedItems"
                                    :key="selectedItem.uuid"
                                >
                                    <router-link 
                                        :to="'/cars/' + selectedItem.uuid" 
                                        target="_blank" 
                                        class="uta-firmwares__destination-list-item-link"
                                    >
                                        {{ selectedItem.data.imei }} 
                                    </router-link>
                                    <span 
                                        @click="deleteItem(selectedItem)"
                                        class="material-symbols-outlined uta-firmwares__destination-list-item-delete"
                                    >
                                        close
                                    </span>
                                </div>
                            </template>
                            <template v-if="UTAFirmwaresUploadMethod == 'groups'">
                                <div 
                                    class="uta-firmwares__destination-list-item"
                                    v-for="selectedItem in selectedItems"
                                    :key="selectedItem.uuid"
                                >
                                    <router-link 
                                        :to="'/cars-groups/' + selectedItem.uuid" 
                                        target="_blank" 
                                        class="uta-firmwares__destination-list-item-link"
                                    >
                                        {{ selectedItem.name }} 
                                    </router-link>
                                    <span 
                                        @click="deleteItem(selectedItem)"
                                        class="material-symbols-outlined uta-firmwares__destination-list-item-delete"
                                    >
                                        close
                                    </span>
                                </div>
                            </template>
                        </div>
                    </template>
                    <template v-else>
                        <div class="uta-firmwares__destination-descr" :class="{ 'is-invalid' : formInvalids.UTAFirmwaresSelectElements }">
                            {{ getTranslate.FIRMWARES_FORM_SELECT_CARS }}
                        </div>
                    </template>
                    <a 
                        href="#" 
                        class="uta-btn uta-btn--inline uta-firmwares__destination-select"
                        @click="showFirmwaresSelector = true"
                    >
                        {{ getTranslate.FIRMWARES_SELECTOR_LINK }}
                    </a>
                </div>
                <div v-if="UTAFirmwaresUploadMethod == 'all'">
                    <div class="uta-firmwares__destination-descr">
                        {{ getTranslate.FIRMWARES_FORM_SELECT_WARNING }}
                    </div>
                </div>
            </form>
            <div class="mb-4">
                <div class="input-group uta-input__wrapper uta-search">
                    <button class="btn btn-outline-secondary dropdown-toggle uta-search__filter-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        {{ getTranslate[searchModeText] }}
                    </button>
                    <ul class="dropdown-menu uta-search__filter-menu">
                        <li class="uta-search__filter-menu-item">
                            <a class="dropdown-item uta-search__filter-menu-item-link" href="#" @click.prevent="setSearchMode('')">{{ getTranslate.FIRMWARES_SEARCH_MODE_ALL }}</a>
                        </li>
                        <li  class="uta-search__filter-menu-item">
                            <a class="dropdown-item uta-search__filter-menu-item-link" href="#" @click.prevent="setSearchMode('vin')">{{ getTranslate.FIRMWARES_SEARCH_MODE_DEVICE }}</a>
                        </li>
                        <li  class="uta-search__filter-menu-item">
                            <a class="dropdown-item uta-search__filter-menu-item-link" href="#" @click.prevent="setSearchMode('imei')">{{ getTranslate.FIRMWARES_SEARCH_MODE_MODULE }}</a>
                        </li>
                        <li  class="uta-search__filter-menu-item">
                            <a class="dropdown-item uta-search__filter-menu-item-link" href="#" @click.prevent="setSearchMode('car_number')">{{ getTranslate.FIRMWARES_SEARCH_MODE_VERSION }}</a>
                        </li>
                    </ul>
                    <input 
                        type="text" 
                        class="form-control uta-input__wrapper-input uta-search__input"
                        :placeholder="getTranslate.SEARCH + '...'" 
                        v-model="inputSearch"
                        @keyup.escape="inputSearch = '', getList()"
                    >
                    <template v-if="inputSearch.length > 2">
                        <span class="material-icons uta-input__wrapper-icon" @click="inputSearch = '', getList()">
                            cancel
                        </span>
                    </template>
                    <template v-else>
                        <span class="material-icons uta-input__wrapper-icon">
                            search
                        </span>
                    </template>
                </div>
            </div>

            <div 
                v-if="'success' in firmwaresMsg && !firmwaresMsg.success"
                class="my-4 uta-alert" 
                :class="{'uta-alert--danger': !firmwaresMsg.success}"
            >
                <div class="uta-alert__icon">
                    <span class="material-icons">
                        {{ firmwaresMsg.success ? 'check_circle' : 'error_outline' }}
                    </span>
                </div>
                <div class="uta-alert__text">
                    {{ getTranslate[firmwaresMsg.text] || firmwaresMsg.text }}
                </div>
            </div>

            <div 
                v-if="'success' in firmwaresCreateMsg"
                class="my-4 uta-alert" 
                :class="{
                    'uta-alert--success': firmwaresCreateMsg.success, 
                    'uta-alert--danger': !firmwaresCreateMsg.success
                }"
            >
                <div class="uta-alert__icon">
                    <span class="material-icons">
                        {{ firmwaresCreateMsg.success ? 'check_circle' : 'error_outline' }}
                    </span>
                </div>
                <div class="uta-alert__text">
                    {{ getTranslate[firmwaresCreateMsg.text] || firmwaresCreateMsg.text }}
                </div>
                <button type="button" class="uta-alert__close" @click="firmwaresStore.setFirmwaresCreateMsg({})">
                    <span class="material-icons">
                        close
                    </span>
                </button>
            </div>

            <div 
                v-if="'success' in firmwareDeleteMsg"
                class="my-4 uta-alert" 
                :class="{
                    'uta-alert--success': firmwareDeleteMsg.success, 
                    'uta-alert--danger': !firmwareDeleteMsg.success
                }"
            >
                <div class="uta-alert__icon">
                    <span class="material-icons">
                        {{ firmwareDeleteMsg.success ? 'check_circle' : 'error_outline' }}
                    </span>
                </div>
                <div class="uta-alert__text">
                    {{ getTranslate[firmwareDeleteMsg.text] || firmwareDeleteMsg.text }}
                </div>
                <button type="button" class="uta-alert__close" @click="firmwaresStore.setFirmwareDeleteMsg({})">
                    <span class="material-icons">
                        close
                    </span>
                </button>
            </div>

            <div class="container-fluid" v-if="firmwares.array">
                <div class="uta-cars__list uta-list">
                    <div class="uta-list__title d-none d-lg-block uta-cars__title">
                        <div class="row">
                            <div class="col-10">
                                <div class="row">
                                    <div class="col-12 col-lg-4">{{ getTranslate.FIRMWARES_NAME }}</div>
                                    <div class="col-12 col-lg-3">{{ getTranslate.FIRMWARES_DEVICE }}</div>
                                    <div class="col-12 col-lg-3">{{ getTranslate.FIRMWARES_MODULE }}</div>
                                    <div class="col-12 col-lg-2">{{ getTranslate.FIRMWARES_VERSION }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="uta-list__content">
                        <div class="accordion" id="accordionFirmwares">
                            <div 
                                class="row align-items-center accordion-item uta-list__item uta-firmwares__firmware uta-firmwares__firmware--lines" 
                                :class="{ 'uta-list__item--dark' : index % 2 }" 
                                v-for="(firmware, index) in firmwares.array" 
                                :key="firmware.uuid"
                            >
                                <div class="col-10">
                                    <div class="row">
                                        <div class="col-12 col-lg-4 uta-firmwares__firmware-name">
                                            <span class="d-inline d-lg-none uta-firmwares__firmware-mobile-title">{{ getTranslate.FIRMWARES_NAME }}: </span>
                                            <router-link :to="'/firmwares/' + firmware.name">{{ firmware.name }}</router-link>
                                        </div>
                                        <div class="col-12 col-lg-3 uta-firmwares__firmware-device">
                                            <span class="d-inline d-lg-none uta-firmwares__firmware-mobile-title">{{ getTranslate.FIRMWARES_DEVICE }}: </span>
                                            {{ firmware.device || '&mdash;' }}
                                        </div>
                                        <div class="col-12 col-lg-3 uta-firmwares__firmware-module">
                                            <span class="d-inline d-lg-none uta-firmwares__firmware-mobile-title">{{ getTranslate.FIRMWARES_MODULE }}: </span>
                                            {{ firmware.moduleType || '&mdash;' }}
                                        </div>
                                        <div class="col-12 col-lg-2 uta-firmwares__firmware-firmware">
                                            <span class="d-inline d-lg-none uta-firmwares__firmware-mobile-title">{{ getTranslate.FIRMWARES_VERSION }}: </span>
                                            {{ firmware.softwareVersion || '&mdash;' }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-2 text-end">
                                    <span 
                                        class="material-icons p-2 uta-list__item-icon uta-firmwares__firmware-delete-icon"
                                        @click="
                                            showFirmwareDelete = true, 
                                            deleteFirmwareName = firmware.name
                                        "
                                    >
                                        delete
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-4 uta-firmwares__pagination" v-if="firmwares.c && (firmwares.c.isBefore || firmwares.c.isAfter)">
                <div class="row">
                    <div class="col-12 col-xs-6 col-sm-6 col-md-4 col-xl-3 col-xxl-2">
                        <div class="uta-pagination">
                            <button 
                                :disabled="firmwaresProcess || !firmwares.c.isBefore"
                                class="uta-btn uta-btn--sm uta-pagination__prev" 
                                @click.prevent="changePage(firmwares.c.start, 'before')"
                            >
                                <span class="material-icons">
                                    navigate_before
                                </span>
                            </button>
                            <div class="uta-pagination__current">
                                {{ pageNumber }}
                            </div>
                            <button 
                                :disabled="firmwaresProcess || !firmwares.c.isAfter"
                                class="uta-btn uta-btn--sm uta-pagination__next" 
                                @click.prevent="changePage(firmwares.c.stop, 'after')"
                            >
                                <span class="material-icons">
                                    navigate_next
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <transition name="bounce">
            <Modal 
                v-if="showFirmwaresSelector"
                :header="getTranslate.FIRMWARES_SELECTOR"
                :size="'lg'"
                @closeModal="showFirmwaresSelector = false"
            >
                <template v-slot:body>
                    <UTAListSelector 
                        @addItem="addItem"
                        @deleteItem="deleteItem"
                        :sourceListSelected="selectedItems"
                        :sourceList="sourceList"
                        :sourceListLabels="sourceListLabels"
                        :sourceListNames="sourceListNames"
                        @closeModal="showFirmwaresSelector = false" 
                    />
                </template>
            </Modal>
        </transition>

        <transition>
            <Modal
                v-if="showFirmwareDelete"
                :header="getTranslate.FIRMWARES_DELETE"
                size="md"
                @closeModal="showFirmwareDelete = false"
            >
                <template v-slot:body>
                    <form action="" @submit.prevent="firmwaresStore.deleteFirmwares(deleteFirmwareName)">
                        {{ getTranslate.FIRMWARES_DELETE_DESCR }}
                        <div class="mt-5 uta-btns">
                            <button type="button" class="uta-btn" @click="showFirmwareDelete = false">{{ getTranslate.BTN_CANCEL }}</button>
                            <button type="submit" class="uta-btn uta-btn--main" :disabled="firmwaresDeleteProcess">{{ getTranslate.BTN_DELETE }}</button>
                        </div>
                    </form>
                </template>
            </Modal>
        </transition>

    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/components/firmwares.scss';
</style>